import styles from "./Divider.module.css";

interface DividerProps {
  type?: "solid" | "dashed";
}

const Divider: React.FC<DividerProps> = ({ type }) => {
  const style: React.CSSProperties = { borderTopStyle: type };

  return <hr className={styles.container} style={style} />;
};

export { Divider };
